import React, { useState } from 'react'
import Cropper from 'react-easy-crop'
import { getCroppedImage } from '../helpers/getCroppedImage'
import { makeStyles } from '@material-ui/core/styles'
import {
  Button,
  Slider
} from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  cropper: {
    position: 'relative',
    width: '350px',
    height: '450px'
  },
  slider: {
    marginTop: '15px'
  },
  btn: {
    margin: '5px 0',
    float: 'right'
  }
}))

const AvatarCropper = ({inputImage, setIsCropping, handleAvatar}) => {
  const classes = useStyles()
  const [crop, setCrop] = useState({x: 0, y: 0})
  const [zoom, setZoom] = useState(1)
  const [outputImage, setOutputImage] = useState(null)

  const onCropComplete = async (croppedArea, croppedAreaPixels) => {
    const croppedImage = await getCroppedImage(inputImage, croppedAreaPixels)
    setOutputImage(croppedImage)
  }

  const handleOutputImage = () => {
    setIsCropping(false)
    handleAvatar(outputImage)
  }

  return(
    <>
      <div className={classes.cropper}>
        <Cropper
          image={inputImage}
          crop={crop}
          zoom={zoom}
          aspect={1}
          onCropChange={setCrop}
          onZoomChange={setZoom}
          onCropComplete={onCropComplete}
          cropShape='round'
          showGrid={false}
        />
      </div>
      <Slider
        value={zoom}
        min={1}
        max={3}
        step={0.1}
        aria-labelledby="Zoom"
        onChange={(e, zoom) => setZoom(zoom)}
        className={classes.slider}
      />
      <Button
        variant='contained'
        color='primary'
        onClick={handleOutputImage}
        className={classes.btn}
      >
        OK
      </Button>
    </>
  )
}

export default AvatarCropper
